module.exports = __webpack_public_path__ + "static/blog69-f257fa54762d480400eba7ac7fefd6ab.png";